class HttpCode {
  static _0 = 0
  static _200 = 200
  static _200_S = '200'
  static _400 = 400
  static _401 = 401
  static _403 = 403
  static _404 = 404
  static _500 = 500
  static _501 = 501
  static _CANCLE = 1000
  static _TIMEOUT = 2000
  static _OTHER = 9999
}

export default HttpCode
